
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift-card/selection",
      function () {
        return require("private-next-pages/gift-card/selection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gift-card/selection"])
      });
    }
  